/* HMX V34 — purchase motion stays disabled on the four wallet experiment arms.
   Other product pages retain the original first pulse after 5 seconds and 9-second cooldown. */
(() => {
  'use strict';

  if (window.__HMX_DIRECT_LEFT_MOTION_V33__) return;
  window.__HMX_DIRECT_LEFT_MOTION_V33__ = true;

  const selector = [
    '.hmx-v2__atc',
    '[data-hmx-submit]',
    '.hmx-v2__sticky button',
    '[data-hmx-sticky-button]',
    '.hmx-v21-modal__atc',
    '[data-hmx-modal-atc]',
    '.hmx-collection__modal-atc',
    '.product-form__submit',
    'form[action*="/cart/add"] button[name="add"]',
    '[id^="SectionAtcBtn-"]'
  ].join(',');

  const repeatDelay = 9000;
  const initialDelay = 5000;
  let lastPulseAt = 0;
  let active = null;

  const walletExperimentActive = () => {
    const root = document.documentElement;
    return Boolean(
      root && (
        root.dataset.hmxWalletTest ||
        root.classList.contains('hmx-wallet-experiment') ||
        root.classList.contains('hmx-wallet-test-a') ||
        root.classList.contains('hmx-wallet-test-b') ||
        root.classList.contains('hmx-wallet-test-c') ||
        root.classList.contains('hmx-wallet-test-d')
      )
    );
  };

  const visibleAndEnabled = (element) => {
    if (!(element instanceof HTMLElement)) return false;
    if (element.disabled || element.hidden || element.getAttribute('aria-disabled') === 'true') return false;

    const styles = window.getComputedStyle(element);
    if (styles.display === 'none' || styles.visibility === 'hidden' || Number(styles.opacity) === 0) return false;

    const rect = element.getBoundingClientRect();
    const viewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
    const viewportWidth = window.visualViewport ? window.visualViewport.width : window.innerWidth;

    return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < viewportHeight && rect.right > 0 && rect.left < viewportWidth;
  };

  const pickTarget = () => {
    const elements = Array.from(document.querySelectorAll(selector)).filter(visibleAndEnabled);
    if (!elements.length) return null;

    return elements.find((element) => element.matches('.hmx-v2__atc, [data-hmx-submit]'))
      || elements.find((element) => !element.closest('.hmx-v2__sticky, [data-hmx-sticky], .sticky-atc, .sticky-add-to-cart'))
      || elements[0];
  };

  const restore = () => {
    if (!active) return;

    active.timers.forEach(window.clearTimeout);
    const { element, position, left, willChange } = active;
    element.removeAttribute('data-hmx-v33-moving');

    if (position) element.style.setProperty('position', position.value, position.priority);
    else element.style.removeProperty('position');

    if (left) element.style.setProperty('left', left.value, left.priority);
    else element.style.removeProperty('left');

    if (willChange) element.style.setProperty('will-change', willChange.value, willChange.priority);
    else element.style.removeProperty('will-change');

    active = null;
  };

  const shake = (element) => {
    if (active || walletExperimentActive()) return;

    const readInline = (property) => {
      const value = element.style.getPropertyValue(property);
      return value ? { value, priority: element.style.getPropertyPriority(property) } : null;
    };

    active = {
      element,
      timers: [],
      position: readInline('position'),
      left: readInline('left'),
      willChange: readInline('will-change')
    };

    element.setAttribute('data-hmx-v33-moving', 'true');
    element.style.setProperty('position', 'relative', 'important');
    element.style.setProperty('left', '0px', 'important');
    element.style.setProperty('will-change', 'left', 'important');

    const frames = [
      [0, 0],
      [-8, 85],
      [8, 175],
      [-6, 275],
      [6, 375],
      [-3, 485],
      [3, 585],
      [0, 700]
    ];

    frames.forEach(([pixels, delay]) => {
      active.timers.push(window.setTimeout(() => {
        if (active && active.element === element) {
          element.style.setProperty('left', `${pixels}px`, 'important');
        }
      }, delay));
    });

    active.timers.push(window.setTimeout(restore, 760));
  };

  const pulse = () => {
    if (walletExperimentActive()) {
      restore();
      return;
    }
    if (document.hidden || active) return;

    const now = Date.now();
    if (lastPulseAt && now - lastPulseAt < repeatDelay) return;

    const target = pickTarget();
    if (!target) return;

    lastPulseAt = now;
    shake(target);
  };

  const start = () => {
    window.setTimeout(() => {
      pulse();
      window.setInterval(pulse, 250);
    }, initialDelay);
  };

  document.addEventListener('pointerdown', (event) => {
    if (event.target.closest?.(selector)) {
      lastPulseAt = Date.now();
      restore();
    }
  }, { passive: true });

  document.addEventListener('touchstart', (event) => {
    if (event.target.closest?.(selector)) {
      lastPulseAt = Date.now();
      restore();
    }
  }, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
